import { Header, Table } from "semantic-ui-react"
import CollectionUtils from "../../../utils/collections"
import AcrivityLogRepo from "../../../utils/repository/activityLogRepo"
import { useEffect, useMemo, useState } from "react"
import { serverToLocalDate, serverToLocalTime, utcToSofia } from "../../../utils/dateTimeUtils"
import Alert from "../../../utils/alert"
import Assert from "../../../utils/asserts"
import useDateRange from '../../../hooks/useDateRange'
import { subDays } from "date-fns"
import RangeDatePicker from "../../../components/rangeDatePicker"
import { getTableModel } from "./utils"
import TotalStatsTable from "./components/totalStatsTable"
import useUsersMap from "../../../hooks/useUsersMap"
import Loader from "../../../components/loader";
import { ROLES } from "../../../constnats/user";

function ActivityLogs() {
    const [logs, setLogs] = useState([])

    const { from, to, handleFromChange, handleToChange, handleMoveToNextMonth, handleMoveToPrevMonth } = useDateRange({ from: subDays(new Date(), 7), to: new Date() })

    const fromTM = useMemo(() => new Date(from.getTime()).setUTCHours(0, 0, 0, 0), [from])
    const toTM = useMemo(() => new Date(to.getTime()).setUTCHours(23, 59, 0, 0), [to])


    if (((to - from) / (1000 * 3600 * 24)) > 31) {
        Alert.warn("The specified period cannot be higher than 31 days")
        handleFromChange(to);
    }

    useEffect(() => AcrivityLogRepo.list(
        { from: fromTM, to: toTM },
        logs => setLogs(logs.sort(function (a, b) {
            return new Date(b.start) - new Date(a.start);
        }))
    ), [fromTM, toTM])

    const { usersMap, loading: loadingUsersMap } = useUsersMap({includeDisabled: true, userRoles: [ROLES.EMPLOYEE]})
    
    if(loadingUsersMap) {
        return <Loader/>;
    }

    const { rows, middleDuration, totalClicks, totalKeystrokes, userIds } = getTableModel(logs)
    
    return logs.length === 0 ? <>No Logs</> : <>
        <RangeDatePicker from={from} to={to}
            handleFromChange={handleFromChange} handleToChange={handleToChange}
            handleMoveToNextMonth={handleMoveToNextMonth} handleMoveToPrevMonth={handleMoveToPrevMonth} />
        <TotalStatsTable middleDuration={middleDuration} totalClicks={totalClicks} totalKeystrokes={totalKeystrokes} />
        <div className="activityLogsTable">

            <Table className="activityLogsTableZ" striped celled >
                <Table.Header>
                    <Table.Row >
                        <Table.HeaderCell>Date</Table.HeaderCell>
                        {userIds.map((uid) => <Table.HeaderCell key={uid}> {usersMap[uid]?.fullName ?? "Unknown User"}</Table.HeaderCell>)}
                    </Table.Row>
                </Table.Header>
                <Table.Header className="subHeader">
                    <Table.Row >
                        <Table.HeaderCell></Table.HeaderCell>
                        {userIds.map(uid =>
                            <Table.HeaderCell key={uid}>
                                <Table fixed >
                                    <Table.Header>
                                        <Table.Row >
                                            <Table.HeaderCell>Duration 2M</Table.HeaderCell>
                                            <Table.HeaderCell>Duration 5M</Table.HeaderCell>
                                            <Table.HeaderCell>Duration 10M</Table.HeaderCell>
                                            <Table.HeaderCell>Clicks</Table.HeaderCell>
                                            <Table.HeaderCell>Keystrokes</Table.HeaderCell>
                                            <Table.HeaderCell>Start</Table.HeaderCell>
                                            <Table.HeaderCell>End</Table.HeaderCell>
                                            <Table.HeaderCell>End-Start</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                </Table>
                            </Table.HeaderCell>)}
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {rows.map((cells, i) =>
                        <Table.Row key={i} >
                            {cells.map((cellData, ci) => <Table.Cell key={ci}>
                                {cellData}
                            </Table.Cell>)}
                        </Table.Row>
                    )}
                </Table.Body>
            </Table>
        </div>
    </>
}

export { ActivityLogs }
